import { requiredImageFileValidator } from '../components/Forms/validators'

export const TenantForm = {
  model: 'Tenant',
  format: [
    {
      widths: 'equal',
      fields: {
        name: {
          type: 'text',
          required: true,
        },
        domain: {
          type: 'text',
          required: true,
          disabled: true,
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        deployment_email: {
          type: 'text',
          label: 'Business Email',
        },
        industry: {
          type: 'text',
          label: 'Industry',
        },
        deployment_logo: {
          type: 'file',
          label: 'Logo',
          validator: (input) => {
            return requiredImageFileValidator(input)
          },
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        deployment_primary_color: {
          type: 'text',
          label: 'Primary Color',
        },
        deployment_secondary_color: {
          type: 'text',
          label: 'Secondary Color',
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        what_is_description: {
          type: 'text',
          label: 'Homepage Description',
        },
        bottom_image: {
          type: 'file',
          label: 'Homepage Bottom Image',
          validator: (input) => {
            return requiredImageFileValidator(input)
          },
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        homepage_subtitle: {
          type: 'text',
          label: 'Position',
        },
        homepage_title_image: {
          type: 'file',
          label: 'Homepage Title Image',
          validator: (input) => {
            return requiredImageFileValidator(input)
          },
        },
      },
    },
  ],
}
